import { render, staticRenderFns } from "./TradeOrganization.vue?vue&type=template&id=2f811e8e"
import script from "./TradeOrganization.vue?vue&type=script&lang=js"
export * from "./TradeOrganization.vue?vue&type=script&lang=js"
import style0 from "./TradeOrganization.vue?vue&type=style&index=0&id=2f811e8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports